import React, { useContext } from 'react';
import { Flex } from 'antd';

import BasePane from '@totem/components/BasePane';
import CloseButton from '@totem/components/ticketing/details/headerButtons/closeButton';
import ResolveButton from '@totem/components/ticketing/details/headerButtons/resolveButton';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import CardBody from '@totem/components/ui_components/cards/CardBody';
import CardHeader from '@totem/components/ui_components/cards/CardHeader';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';
import NAApprovalSection from '@totem/components/unauthenticated/ticketing/details/approvals/naApprovalSection';
import NATicketHeader from '@totem/components/unauthenticated/ticketing/details/naTicketHeader';
import NaTicketTabs from '@totem/components/unauthenticated/ticketing/details/naTicketTabs';
import { staticLogoLarge } from '@totem/selectors/preferencesSelectors';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull } from '@totem/utilities/common';

import '../../../base.css';

const logo = staticLogoLarge;

const styles = {
  icon: {
    fontSize: '48px',
  },
  ticketNumber: {
    fontSize: '36px',
  },
};

const NaTicketLayout = () => {
  const { ticket } = useContext(TicketContext);

  return (
    <BasePane>
      <PrimaryContentPane>
        {isNotNull(ticket) && (
          <CardHeader>
            <Flex
              justify="space-between"
              align="center"
              style={{ width: '100%' }}
            >
              <Flex justify={'flex-start'} align={'center'}>
                <IBDIcon name={ticket.ticket.type} style={styles.icon} />
                <div style={{ marginRight: 24 }}>{'  '}</div>
                <div style={styles.ticketNumber}>{ticket.ticket.number}</div>
              </Flex>
              <Flex justify={'flex-end'} align={'center'}>
                <ResolveButton buttonProps={{ size: 'small' }} />
                <CloseButton buttonProps={{ size: 'small' }} />
                <div>
                  <img
                    alt="Logo"
                    src={logo}
                    style={{
                      height: '100px',
                      width: 'auto',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </Flex>
            </Flex>
          </CardHeader>
        )}
        <CardBody>
          {isNotNull(ticket) && (
            <>
              <NATicketHeader ticket={ticket} />
              <br />
              <NAApprovalSection />
              <br />
              <NaTicketTabs />
            </>
          )}
        </CardBody>
      </PrimaryContentPane>
    </BasePane>
  );
};

export default NaTicketLayout;
